export default function LeftArrow() {
  return (
    <svg
      width="39"
      height="40"
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0013 36.6663C10.7966 36.6663 3.33464 29.2044 3.33464 19.9997C3.33464 10.7949 10.7966 3.33301 20.0013 3.33301C29.206 3.33301 36.668 10.7949 36.668 19.9997C36.668 29.2044 29.206 36.6663 20.0013 36.6663Z"
        fill="#00C6AE"
      />
      <path
        d="M21.5 26.6663C21.5 26.6663 16.5 21.7563 16.5 19.9997C16.5 18.2428 21.5 13.333 21.5 13.333"
        stroke="#374151"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
